export default "__VITE_ASSET__DIomTjml__"